import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const swipers = {};

window.Drupal.behaviors.applicationSelectors = {
    attach: function (context) {
        once('applications-selectors', '.applications-selectors', context).forEach((selectors) => {
            selectors.querySelectorAll('.applications-selectors__title').forEach((button) => {
                button.addEventListener('click', (e) => {
                    selectors.querySelectorAll('.applications-selectors__title').forEach((el) => {
                        el.classList.remove('button--primary');
                        el.classList.add('button--ghost');
                    });
                    button.classList.add('button--primary');
                    button.classList.remove('button--ghost');

                    const tab = button.dataset.tabButton;
                    selectors.querySelector('.applications-selectors__item.active').classList.remove('active');
                    selectors
                        .querySelector(`.applications-selectors__item[data-tab-content="${tab}"]`)
                        .classList.add('active');
                });
            });
        });
    },
};

window.Drupal.behaviors.applicationSelectorSwiper = {
    attach: function (context) {
        once('application-selector-swiper', '.applications-selector', context).forEach((selector) => {
            const type = selector.dataset.selectorType;
            swipers[type] = new Swiper(selector.querySelector('.swiper'), {
                modules: [Navigation],
                navigation: {
                    nextEl: selector.querySelector('.swiper-button-next'),
                    prevEl: selector.querySelector('.swiper-button-prev'),
                },
                autoHeight: true,
            }).on('activeIndexChange', (e) => {
                selector.querySelectorAll('button.active').forEach((button) => button.classList.remove('active'));
                selector
                    .querySelectorAll(`[data-selector-button="${e.activeIndex}"]`)
                    .forEach((button) => button.classList.add('active'));
            });

            selector.querySelectorAll('button[data-selector-button]').forEach((button) => {
                button.addEventListener('click', (e) => {
                    swipers[type].slideTo(button.dataset.selectorButton);
                });
            });
        });
    },
};
